const deliveryStatusParent = document.querySelector('.delivery-status');
if (deliveryStatusParent) {
  const totalSteps = document.querySelectorAll('.delivery-status__item');
  const statusActiveItems = document.querySelectorAll('.delivery-status__item.is-active');
  deliveryStatusParent.style.setProperty('--completed-step', statusActiveItems.length);
  deliveryStatusParent.style.setProperty('--total-steps', totalSteps.length);
}
